import React, { useState } from 'react';
import { Search, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = ({ onSearch, searchQuery }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="bg-gray-900 text-white sticky top-0 z-50 shadow-lg">
            {/* Main Header */}
            <div className="max-w-7xl mx-auto px-4 py-2">
                <div className="flex flex-col md:flex-row items-center gap-6 px 8">
                    {/* Logo and Mobile Menu Button */}
                    <div className="flex items-center justify-between w-full md:w-auto">
                        <Link to="/" className="flex items-center transition-smooth hover:opacity-80">
                            <img
                                src="/white-logo.png"
                                alt="Logo"
                                className="h-20 w-60 md:h-28 md:w-80 object-cover" // Adjusted logo size for mobile
                            />
                        </Link>

                        {/* Mobile Menu Button */}
                        <button
                            className="md:hidden transition-smooth hover:opacity-80"
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                        >
                            <Menu className="h-6 w-6" />
                        </button>
                    </div>

                    {/* Search Bar */}
                    <div className="flex flex-1 w-full md:max-w-3xl"> {/* Full width on mobile, increased width on desktop */}
                        <div className="relative w-full">
                            <input
                                type="text"
                                placeholder="Search products..."
                                className="w-full px-4 py-2 pl-10 pr-4 text-gray-900 bg-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-smooth"
                                onChange={(e) => onSearch(e.target.value)}
                                value={searchQuery} // Controlled input
                            />
                            <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Categories Bar */}
            <div
                className={`bg-gray-800 overflow-x-auto ${
                    isMenuOpen ? 'block' : 'hidden md:block'
                }`}
            >
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 py-2">
                        <Link
                            to="/search?category=Footwear"
                            className="text-sm whitespace-nowrap hover:text-blue-400 transition-smooth"
                        >
                            Footwear
                        </Link>
                        <Link
                            to="/search?category=Apparel"
                            className="text-sm whitespace-nowrap hover:text-blue-400 transition-smooth"
                        >
                            Apparel
                        </Link>
                        <Link
                            to="/search?category=Analog Watches"
                            className="text-sm whitespace-nowrap hover:text-blue-400 transition-smooth"
                        >
                            Analog Watches
                        </Link>
                        <Link
                            to="/search?category=Sports"
                            className="text-sm whitespace-nowrap hover:text-blue-400 transition-smooth"
                        >
                            Sports
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;